exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#main {\n  position: relative;\n}\n", "", {"version":3,"sources":["C:/xampp/htdocs/aQuest_GitHub/apps_admin-master/src/src/Layout.vue"],"names":[],"mappings":";AAkBA;EACA,mBAAA;CACA","file":"Layout.vue","sourcesContent":["<template>\n  <div id=\"main\">\n    <Breadcrumbs />\n    <Mainmenu />\n    <slot />\n  </div>\n</template>\n\n<script>\n  import Breadcrumbs from './Breadcrumbs';\n  import Mainmenu from './Mainmenu';\n\n  export default {\n    components: {Breadcrumbs, Mainmenu},\n  }\n</script>\n\n<style>\n  #main {\n    position: relative;\n  }\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64778763","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Layout.vue
// module id = W02O
// module chunks = 13